// extracted by mini-css-extract-plugin
export var videoWrapper = "video-module--videoWrapper--tpk59";
export var videoWrapperLightbox = "video-module--videoWrapperLightbox--TW96I";